import { render, staticRenderFns } from "./supplier-commitment-target.vue?vue&type=template&id=13281b82&scoped=true"
import script from "./supplier-commitment-target.vue?vue&type=script&lang=js"
export * from "./supplier-commitment-target.vue?vue&type=script&lang=js"
import style0 from "./supplier-commitment-target.vue?vue&type=style&index=0&id=13281b82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13281b82",
  null
  
)

export default component.exports